function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13;
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 32,
    viewBox: "0 0 109 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 109,
    height: 32,
    fill: "#DFDFDF",
    style: (_ref2 = {
      fill: "#DFDFDF"
    }, _defineProperty(_ref2, "fill", "color(display-p3 0.8763 0.8763 0.8763)"), _defineProperty(_ref2, "fillOpacity", 1), _ref2)
  }), /*#__PURE__*/React.createElement("g", {
    id: "Final Design"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2979 -966C-2979 -967.105 -2978.1 -968 -2977 -968H6023C6024.1 -968 6025 -967.105 6025 -966V3354C6025 3355.1 6024.1 3356 6023 3356H-2977C-2978.1 3356 -2979 3355.1 -2979 3354V-966Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2977 -967H6023V-969H-2977V-967ZM6024 -966V3354H6026V-966H6024ZM6023 3355H-2977V3357H6023V3355ZM-2978 3354V-966H-2980V3354H-2978ZM-2977 3355C-2977.55 3355 -2978 3354.55 -2978 3354H-2980C-2980 3355.66 -2978.66 3357 -2977 3357V3355ZM6024 3354C6024 3354.55 6023.55 3355 6023 3355V3357C6024.66 3357 6026 3355.66 6026 3354H6024ZM6023 -967C6023.55 -967 6024 -966.552 6024 -966H6026C6026 -967.657 6024.66 -969 6023 -969V-967ZM-2977 -969C-2978.66 -969 -2980 -967.657 -2980 -966H-2978C-2978 -966.552 -2977.55 -967 -2977 -967V-969Z",
    fill: "black",
    fillOpacity: 0.1,
    style: {
      fill: "black",
      fillOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Company"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_213_6949)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -24,
    y: -24,
    width: 1200,
    height: 1715,
    fill: "#F2F4FE",
    style: (_ref3 = {
      fill: "#F2F4FE"
    }, _defineProperty(_ref3, "fill", "color(display-p3 0.9490 0.9569 0.9961)"), _defineProperty(_ref3, "fillOpacity", 1), _ref3)
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1171277637"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1171277639"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Padm\xC3\xA9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M106.479 7.13281L104.24 10.5139H102.184L103.897 7.13281H106.479ZM103.235 23.4441C99.8765 23.4441 97.5234 20.9997 97.5234 17.5044C97.5234 13.9635 99.8308 11.5191 103.143 11.5191C106.524 11.5191 108.672 13.7807 108.672 17.2988V18.1441L100.173 18.1669C100.379 20.1545 101.43 21.1596 103.28 21.1596C104.811 21.1596 105.816 20.5657 106.136 19.492H108.717C108.238 21.9592 106.182 23.4441 103.235 23.4441ZM103.166 13.8036C101.521 13.8036 100.516 14.6945 100.242 16.385H105.908C105.908 14.8316 104.834 13.8036 103.166 13.8036Z",
    fill: "#18181D",
    style: (_ref4 = {
      fill: "#18181D"
    }, _defineProperty(_ref4, "fill", "color(display-p3 0.0941 0.0941 0.1137)"), _defineProperty(_ref4, "fillOpacity", 1), _ref4)
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M80.7617 23.1476H77.9746V11.8622H80.5333L80.7617 13.1872C81.3328 12.2506 82.4751 11.5195 84.0971 11.5195C85.8104 11.5195 86.9984 12.3648 87.5924 13.667C88.1635 12.3648 89.4885 11.5195 91.2019 11.5195C93.9433 11.5195 95.451 13.1644 95.451 15.7687V23.1476H92.6868V16.4997C92.6868 14.8777 91.8187 14.0325 90.4937 14.0325C89.1458 14.0325 88.1178 14.9006 88.1178 16.751V23.1476H85.3307V16.4769C85.3307 14.9006 84.4854 14.0553 83.1604 14.0553C81.8354 14.0553 80.7617 14.9234 80.7617 16.751V23.1476Z",
    fill: "#18181D",
    style: (_ref5 = {
      fill: "#18181D"
    }, _defineProperty(_ref5, "fill", "color(display-p3 0.0941 0.0941 0.1137)"), _defineProperty(_ref5, "fillOpacity", 1), _ref5)
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M68.4661 23.444C65.1992 23.444 63.166 21.0453 63.166 17.55C63.166 14.0319 65.2221 11.519 68.626 11.519C70.2023 11.519 71.5958 12.1815 72.304 13.3009V6.15039H75.0683V23.1471H72.5096L72.3269 21.388C71.6415 22.6902 70.1794 23.444 68.4661 23.444ZM69.0829 20.8854C71.0247 20.8854 72.2812 19.4919 72.2812 17.4587C72.2812 15.4255 71.0247 14.0091 69.0829 14.0091C67.141 14.0091 65.9531 15.4483 65.9531 17.4587C65.9531 19.469 67.141 20.8854 69.0829 20.8854Z",
    fill: "#18181D",
    style: (_ref6 = {
      fill: "#18181D"
    }, _defineProperty(_ref6, "fill", "color(display-p3 0.0941 0.0941 0.1137)"), _defineProperty(_ref6, "fillOpacity", 1), _ref6)
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M54.6713 23.4446C52.2726 23.4446 50.8105 22.0511 50.8105 19.9265C50.8105 17.8476 52.3183 16.5454 54.9912 16.3398L58.3722 16.0885V15.8372C58.3722 14.3066 57.4584 13.6898 56.0421 13.6898C54.3972 13.6898 53.4834 14.3752 53.4834 15.5631H51.1075C51.1075 13.1187 53.1179 11.5195 56.1791 11.5195C59.2175 11.5195 61.0908 13.1644 61.0908 16.2941V23.1476H58.6464L58.4408 21.4799C57.961 22.645 56.4304 23.4446 54.6713 23.4446ZM55.5851 21.3429C57.2985 21.3429 58.3951 20.3149 58.3951 18.5786V17.9847L56.0421 18.1674C54.3058 18.3273 53.6433 18.8985 53.6433 19.8123C53.6433 20.8403 54.3287 21.3429 55.5851 21.3429Z",
    fill: "#18181D",
    style: (_ref7 = {
      fill: "#18181D"
    }, _defineProperty(_ref7, "fill", "color(display-p3 0.0941 0.0941 0.1137)"), _defineProperty(_ref7, "fillOpacity", 1), _ref7)
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M44.1823 17.392H40.5042V23.1489H37.5801V6.44922H44.1823C47.5405 6.44922 49.7108 8.64234 49.7108 11.9092C49.7108 15.1303 47.5176 17.392 44.1823 17.392ZM43.6112 9.05355H40.5042V14.7876H43.5655C45.5758 14.7876 46.6495 13.7139 46.6495 11.8863C46.6495 10.0587 45.553 9.05355 43.6112 9.05355Z",
    fill: "#18181D",
    style: (_ref8 = {
      fill: "#18181D"
    }, _defineProperty(_ref8, "fill", "color(display-p3 0.0941 0.0941 0.1137)"), _defineProperty(_ref8, "fillOpacity", 1), _ref8)
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 3498"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.99712 2.48438H20.8199C26.9945 2.48438 32 7.48989 32 13.6645C32 19.8391 26.9945 24.8446 20.8199 24.8446H0L5.99712 2.48438Z",
    fill: "#18181D",
    style: (_ref9 = {
      fill: "#18181D"
    }, _defineProperty(_ref9, "fill", "color(display-p3 0.0941 0.0941 0.1137)"), _defineProperty(_ref9, "fillOpacity", 1), _ref9)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99712 2.48438H20.8199C26.9945 2.48438 32 7.48989 32 13.6645C32 19.8391 26.9945 24.8446 20.8199 24.8446H0L5.99712 2.48438Z",
    fill: "url(#paint0_linear_213_6949)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 3491"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6617 0H23.9516L15.3719 32H3.08203L11.6617 0Z",
    fill: "#394DFC",
    style: {
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 691"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.6212,
    cy: 13.7141,
    rx: 7.10559,
    ry: 7.0559,
    fill: "#18181D",
    style: (_ref10 = {
      fill: "#18181D"
    }, _defineProperty(_ref10, "fill", "color(display-p3 0.0941 0.0941 0.1137)"), _defineProperty(_ref10, "fillOpacity", 1), _ref10)
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.6212,
    cy: 13.7141,
    rx: 7.10559,
    ry: 7.0559,
    fill: "#F2F4FE",
    style: (_ref11 = {
      fill: "#F2F4FE"
    }, _defineProperty(_ref11, "fill", "color(display-p3 0.9490 0.9569 0.9961)"), _defineProperty(_ref11, "fillOpacity", 1), _ref11)
  }))))))))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_213_6949",
    x1: 34.2609,
    y1: 13.6066,
    x2: -10.6667,
    y2: 13.6066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263CFF",
    style: (_ref12 = {
      stopColor: "#263CFF"
    }, _defineProperty(_ref12, "stopColor", "color(display-p3 0.1490 0.2353 1.0000)"), _defineProperty(_ref12, "stopOpacity", 1), _ref12)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFC5",
    style: (_ref13 = {
      stopColor: "#00FFC5"
    }, _defineProperty(_ref13, "stopColor", "color(display-p3 0.0000 1.0000 0.7725)"), _defineProperty(_ref13, "stopOpacity", 1), _ref13)
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_213_6949"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -24,
    y: -24,
    width: 1200,
    height: 1715,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8c9e453ac3911a935e7dc3b83c1f3059.svg";
export { ForwardRef as ReactComponent };